import React from 'react';

const HeaderSection = ({ 
  title = "HOW WE WORK",
  mainHeading = "How NKENNEAi Connects Africa To The World",
  subtitle = "We're breaking language barriers with AI-powered translation and speech tools, enabling seamless communication, integration, and global connectivity."
}) => {
  return (
    <div className="flex flex-col items-center m-4" style={{ minWidth: '320px', maxWidth: '1071px', height: '165px' }}>
      <h2 className="text-[#ef8702] font-black text-base">
        {title}
      </h2>
      <div className="flex flex-col items-center gap-4 mt-8">
        <h1 className="text-black font-black text-4xl md:text-[45px] text-center">
          {mainHeading}
        </h1>
        <p className="text-black text-base text-center max-w-[761px]">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default HeaderSection;

